import React from 'react';

const DescriptionModal = ({
  showDescription,
  setShowDescription,
  modalStyles,
  title = 'Description',
  field = 'Description'
}) => {
  if (!showDescription) return null;

  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.box}>
        <button
          onClick={() => setShowDescription(null)}
          style={modalStyles.closeButton}
        >
          ×
        </button>
        <h3 style={modalStyles.modalTitle}>{title}</h3>
        <p>{showDescription[field]}</p>
      </div>
    </div>
  );
};

export default DescriptionModal;
